import { Tab } from '../const';

/**
 * @function convertFromTabToGroupTab
 * @param { array } tabs
 * @param { string } groupId
 * @returns { array }
 */
function convertFromTabToGroupTab(tabs, groupId) {
	const results = tabs.map((tab) => {
		return {
			[Tab.GroupId]: groupId,
			[Tab.Id]: tab.id,
			[Tab.Name]: tab.name,
			[Tab.Url]: tab.url,
			[Tab.Desc]: tab.desc,
			[Tab.Order]: '',
			[Tab.Checked]: false,
			[Tab.Subtabs]: [],
			[Tab.SubtabId]: '',
		};
	});

	return results;
}

export default convertFromTabToGroupTab;
